var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr",staticStyle:{"text-align":"center"}},[_c('div',[_c('qrcode-vue',{attrs:{"value":_vm.url,"size":_vm.size,"level":"H"}})],1),(_vm.column.remote)?_c('div',{staticClass:"refresh",on:{"click":_vm.handleRefresh}},[_vm._v("刷新二维码")]):_vm._e(),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.tip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }